import React from "react";
import {AOperation} from "../../../models/operations/AOperation";
import {autoFormatDate, DATE_FORMAT_WITH_TIME} from "../../../services/UtilsService";
import {operationsWithIconUrls} from "../../../models/utils/EOperationType";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    /**
     * Operation to be displayed.
     */
    operation: AOperation
}

/**
 * Pop-up used for markers representing an operation.
 * @author Alizée Grand
 * @version 1.0
 * @creation 17/03/2022
 * @last_update 17/03/2022
 **/
class OperationPopup extends React.Component<Props> {

    render() {

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        return (

            <p>
                <b>{getTranslation("pages.map.marker.popup.date")}</b>: {autoFormatDate(this.props.operation.date, DATE_FORMAT_WITH_TIME)}
                <br/>
                <b>{getTranslation("pages.map.marker.popup.type")}</b> : {getTranslation(operationsWithIconUrls[this.props.operation.type].translateKeyName)}
                <br/>
                <b>{getTranslation("pages.map.marker.popup.code")}</b> : {this.props.operation.idUser}
            </p>

        );

    };

}

export default withTranslation()(OperationPopup);
